import { FormControl } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

const ToolbarDateRange = ({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <FormControl sx={{ mx: 1, mt: 1, minWidth: 100 }}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          label={label}
          value={value ? moment(value) : null}
          onChange={(newValue) => onChange(newValue?.toISOString() || "")}
          format="MM/DD/YYYY"
          slotProps={{
            textField: {
              placeholder: "MM/DD/YYYY",
              sx: {
                "& input": {
                  fontSize: 14,
                },
              },
              size: "small",
              fullWidth: true,
              variant: "outlined",
              InputLabelProps: {
                shrink: true,
              },
              //   error: !!fieldState.error,
              //   helperText: fieldState.error?.message,
            },
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default ToolbarDateRange;
